import type { ReactNode } from 'react';
import StatementPositiveSolid from '@simplywallst/ui-core/icons/StatementPositiveSolid';
import StatementNegativeSolid from '@simplywallst/ui-core/icons/StatementNegativeSolid';
import StatementNoDataSolid from '@simplywallst/ui-core/icons/StatementNoDataSolid';
import {
  StatementWrapper,
  StatementAnchor,
  StatementTitle,
} from '@/components/Statement/styled';
import type { Statement as StatementType } from '@/hooks/useCompanyStatementsAPIFormatted/types';

//TODO @ric: remove ReduxValue types once Redux statements is completely removed from the Report
type ReduxValue = 'Pass' | 'Fail' | 'No data' | 'UnInitialised';

export type StatementValue = ReduxValue | StatementType['value'];

const getStatementIcon = (value?: StatementValue) => {
  switch (value) {
    case true:
    case 'Pass':
      return <StatementPositiveSolid data-cy-id="pass" />;
    case false:
    case 'Fail':
      return <StatementNegativeSolid data-cy-id="fail" />;
    case null:
    case 'No data':
      return <StatementNoDataSolid data-cy-id="no-data" />;
    default:
      return null;
  }
};

export interface Props {
  value?: StatementValue;
  title?: string;
  description?: ReactNode;
  statementId?: string;
  noIcon?: boolean;
  size?: 'small' | 'default';
}

const Statement = ({
  value,
  title,
  description,
  statementId,
  noIcon,
  size = 'default',
}: Props) => {
  return (
    <StatementWrapper
      value={value}
      noIcon={noIcon}
      size={size}
      data-cy-id={`report-statement-${statementId}`}
    >
      <StatementAnchor id={statementId} />
      {!noIcon && getStatementIcon(value)}
      <p>
        {title && (
          <StatementTitle value={value}>
            {title}
            {description && ': '}
          </StatementTitle>
        )}
        {description}
      </p>
    </StatementWrapper>
  );
};

export default Statement;
